<template>
  <div class="jobView column">
    <Header />
    <Button layout="back" @click="router.back()" class="show-s">
      <i class="fa fa-arrow-left"></i> Voltar
    </Button>
    <div class="content">
      <Job />
    </div>
  </div>
</template>

<script>
import Job from "@/components/JobClient.vue";
import Button from "@/components/Button.vue";
import router from "@/router";

export default {
  name: "JobView",
  components: {
    Job,
    Button
  },
  data() {
    return {
      router: router
    };
  }
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.jobView {
  .content {
    padding: 42px 35px;
    @media (max-width: $small) {
      padding: 7px;
    }
  }
}
</style>
